import React, { FunctionComponent } from 'react';

import { simpleMenuAnimation } from '../../animation/menuAnimation';

import { $MenuContainer, $MenuTransition } from './Menu.styles';
import { MENU_POSITIONS } from './Menu.types';

interface MenuAnimatorProps {
  position?: MENU_POSITIONS | { top: string; left: string };
  dataTestId?: string;
  componentThemeName?: string;
  minWidth?: number;
}
const MenuAnimator: FunctionComponent<
  React.PropsWithChildren<MenuAnimatorProps>
> = ({ position, dataTestId, children, componentThemeName, minWidth }) => {
  return (
    <$MenuContainer $position={position}>
      <$MenuTransition
        $position={position}
        data-testid={dataTestId}
        $componentThemeName={componentThemeName}
        $minWidth={minWidth}
        {...simpleMenuAnimation}
      >
        {children}
      </$MenuTransition>
    </$MenuContainer>
  );
};

export default MenuAnimator;
